module.exports = __webpack_public_path__ + "static/media/statusActive.6cceafa4.svg";